import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { MultiInput } from "components/FormControls/MultiInput/MultiInput";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: { "& .MuiInputBase-root": { backgroundColor: theme.white00 } },
  }),
);

interface Props {
  fieldName: string;
  valueType?: "number" | "text";
}

export const TextArrayConditionValue = ({ fieldName, valueType }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <MultiInput
      valueType={valueType}
      label=""
      formField={fieldName}
      helperText={message({ id: "multiInputHelper" })}
      placeholder={message({ id: "add" })}
      data-test-id="condition-value"
      className={classes.wrapper}
    />
  );
};
